<template>
  <vz-dialog
    ref="dialog"
    :title="title"
    :name="name"
    small
    @showed="showed"
  >
    <vz-form v-model="isValid" ref="form">
      <vz-input
        ref="emailInput"
        v-model="email"
        :rules="[formRules.required, formRules.email]"
        label="E-mail"
        required
      />
    </vz-form>
    <template #footer>
      <vz-button
        variant="primary"
        big
        :disabled="!isValid"
        class="mx-auto"
        @click="submit"
      >
        Отправить
      </vz-button>
    </template>
  </vz-dialog>
</template>

<script setup lang="ts">
import {defineProps} from '@vue/runtime-core';
import formRules from "~/common/vz-form-rules";

const { $hideDialog } = useNuxtApp()
const emit = defineEmits([
  'submit'
])

const props = defineProps({
  name: {
    type: String,
    default: 'vz-email-modal'
  },
  title: {
    type: String,
    default: 'Отправить на email'
  }
})

const isValid = ref(false)
const email = ref('')

const emailInput = ref()
const dialog = ref()

function showed() {
  emailInput.value.onIconClick()
}

function submit() {
  emit('submit', email.value)
  $hideDialog({name: 'vz-email-modal'})
}

function show() {
  dialog.value.show()
}

function hide() {
  dialog.value.hide()
}

defineExpose({
  show,
  hide
})
</script>

<style lang="scss">

</style>
